<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>dynamic_feed</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Manejo de Transferencias</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)">
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col>
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="empresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Créditos de la Empresa"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="filtro.canalVentaId"
              :items="canalesVenta"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Originadas en"
              placeholder="Seleccione un Canal de Venta"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              v-model="filtro.productoId"
              :items="productos"
              autocomplete="disabled"
              item-text="descripcion"
              item-value="id"
              label="Del producto"
              placeholder="Seleccione uno"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
          <v-col>
            <app-selector-periodos
              v-on:update-periodo="
                filtro.periodo = $event
              "></app-selector-periodos>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="2">
            <v-text-field
              v-model="filtro.cui"
              label="Buscar por documento/cuil"></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-autocomplete
              v-model="filtro.formatoId"
              :items="formatos"
              item-text="descripcion"
              item-value="id"
              label="Formato"
              no-data-text="Seleccione una Empresa para ver los Formatos"
              placeholder="Seleccione uno"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
          <v-col>
            <v-flex
              v-if="formatoSeleccionado && formatoSeleccionado.formatoId == 1">
              <v-radio-group
                row
                v-model="filtro.estadoTransferenciaId"
                @change="records = []">
                <v-radio label="UC a Confirmar" value="1"></v-radio>
                <v-radio label="UC Confirmado" value="2"></v-radio>
                <v-radio label="Transferencia Enviada" value="3"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex
              v-if="
                formatoSeleccionado &&
                (formatoSeleccionado.formatoId == 2 ||
                  formatoSeleccionado.formatoId == 3)
              ">
              <v-radio-group row v-model="filtro.estadoTransferenciaId">
                <v-radio label="Créditos por Transferir" value="1"></v-radio>
                <v-radio label="Créditos Transferidos" value="3"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex
              v-if="formatoSeleccionado && formatoSeleccionado.esLlamadoApi">
              <v-alert :value="true" type="info">
                El formato de transferencia elegido es por API, no por archivo.
              </v-alert>
            </v-flex>
          </v-col>
          <v-col cols="2">
            <v-btn color="success" @click="getItems(true)" :disabled="loading"
              >Consultar</v-btn
            >
          </v-col>
        </v-row>

        <v-flex>
          <v-card>
            <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
              <v-icon>list</v-icon>
              <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-data-table
              loading-text="Buscando registros"
              dense
              :headers="headers"
              :items="records"
              :rows-per-page="pagination.itemsPerPage"
              :options.sync="pagination"
              v-model="selectedRows"
              :loading="loading"
              class="elevation-1"
              :footer-props="footer"
              :show-select="records.length > 0"
              item-key="id">
              <template v-slot:header.data-table-select="{ on, props }">
                <v-checkbox
                  @change="selectAllChanged"
                  color="purple"
                  v-bind="props"
                  v-on="on"></v-checkbox>
              </template>

              <template slot="no-data">
                <v-alert :value="true" color="grey" icon="warning">
                  No se encontraron registros con los filtros ingresados
                </v-alert>
              </template>

              <template v-slot:item="{ item, isSelected, select }">
                <tr>
                  <td>
                    <v-simple-checkbox
                      class="caption"
                      color="green"
                      :value="isSelected"
                      @input="select($event)"></v-simple-checkbox>
                  </td>
                  <td>
                    <app-acciones-comunes
                      :documento="item.cuil.toString().substring(2, 10)"
                      :personaId="item.solicitanteId">
                    </app-acciones-comunes>
                  </td>

                  <td class="text-xs-left caption">{{ item.origen }}</td>
                  <td class="text-xs-left caption">{{ item.producto }}</td>
                  <td class="text-xs-left caption">
                    {{ item.estadoTransferencia }}
                  </td>
                  <td class="text-xs-left caption">{{ item.cuil }}</td>
                  <td class="text-xs-left caption">{{ item.solicitante }}</td>
                  <td class="text-xs-left caption">
                    {{ item.monto | currency }}
                  </td>
                  <td class="text-xs-left caption">
                    {{ item.importeTransferencia | currency }}
                    <v-tooltip
                      bottom
                      v-if="
                        item.importeRefinanciaciones > 0 ||
                        item.cargosDescuento > 0
                      ">
                      <template v-slot:activator="{ on }">
                        <v-icon small color="green" v-on="on">info</v-icon>
                      </template>
                      <table>
                        <tr>
                          <span
                            >Se descontaron
                            {{ item.importeRefinanciaciones | currency }} por
                            Crédito/s Refinanciados o Renovados</span
                          >
                        </tr>
                        <tr>
                          <span
                            >Se descontaron
                            {{ item.cargosDescuento | currency }} por Cargos del
                            Plan</span
                          >
                        </tr>
                      </table>
                    </v-tooltip>
                  </td>
                  <td class="text-xs-left caption">{{ item.cbu }}</td>
                  <td class="text-xs-left caption">
                    {{
                      item.fechaIngreso | dateParse() | dateFormat("DD-MM-YYYY")
                    }}
                  </td>
                  <td class="text-xs-left caption">
                    <v-chip small :color="item.empresaColor" label dark>{{
                      item.empresaShort
                    }}</v-chip>
                  </td>
                  <td>
                    <!-- Para los casos con estado UC Confirmado-->
                    <v-tooltip
                      bottom
                      v-if="
                        item.estadoTransferenciaId == 2 ||
                        item.estadoTransferenciaId == 3
                      ">
                      <template v-slot:activator="{ on }">
                        <v-icon
                          small
                          color="red"
                          @click="quitarItem(item)"
                          v-on="on"
                          >clear</v-icon
                        >
                      </template>
                      Quitar caso de la lista de transferencias
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-flex
              v-if="selectedRows"
              class="pl-2 text-xs-right body-2 orange">
              <v-row>
                <v-col cols="2">
                  Total Monto:
                  {{
                    selectedRows.length > 0
                      ? selectedRows
                          .map((i) => i.monto)
                          .reduce((a, b) => a + b, 0)
                      : 0 | currency
                  }}
                </v-col>
                <v-col cols="2">
                  Total Importe Tr:
                  {{
                    selectedRows.length > 0
                      ? selectedRows
                          .map((i) => i.importeTransferencia)
                          .reduce((a, b) => a + b, 0)
                      : 0 | currency
                  }}
                </v-col>
              </v-row>
            </v-flex>
          </v-card>
        </v-flex>

        <v-row>
          <p></p>
        </v-row>

        <v-expansion-panels v-if="recordsConErrores.length > 0">
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-row align="center" no-gutters>
                <v-col cols="1">
                  <v-icon color="red">warning </v-icon>
                </v-col>
                <v-col>
                  <div>Hay Registros con Errores</div>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-flex>
                <v-card>
                  <v-toolbar dense>
                    <v-toolbar-title class="font-weight-light"
                      >Lista de Registros con Errores</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                  </v-toolbar>

                  <v-data-table
                    dense
                    :headers="headersConErrores"
                    :items="recordsConErrores"
                    :server-items-length="recordsConErrores.length"
                    :rows-per-page="pagination.itemsPerPage"
                    :loading="loading"
                    class="elevation-1"
                    :footer-props="footer"
                    item-key="id">
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>
                          <app-acciones-comunes
                            :documento="item.cuil.toString().substring(2, 10)"
                            :personaId="item.solicitanteId">
                          </app-acciones-comunes>
                        </td>

                        <td class="text-xs-left caption">{{ item.origen }}</td>
                        <td class="text-xs-left caption">
                          {{ item.estadoTrasnferencia }}
                        </td>
                        <td class="text-xs-left caption">{{ item.cuil }}</td>
                        <td class="text-xs-left caption">
                          {{ item.solicitante }}
                        </td>
                        <td class="text-xs-left caption">
                          {{ item.monto | currency }}
                        </td>
                        <td class="text-xs-left caption">
                          {{
                            item.fechaIngreso
                              | dateParse()
                              | dateFormat("DD-MM-YYYY")
                          }}
                        </td>

                        <td class="text-xs-left caption">
                          <v-tooltip bottom v-if="item.errores != ''">
                            <template v-slot:activator="{ on }">
                              <v-btn text dark x-small color="red" v-on="on">
                                <v-icon>warning</v-icon>
                              </v-btn>
                            </template>
                            <span class="text-xs-left caption">{{
                              item.errores
                            }}</span>
                          </v-tooltip>
                        </td>

                        <td class="text-xs-left caption">
                          <v-chip small :color="item.empresaColor" label dark>{{
                            item.empresaShort
                          }}</v-chip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-container fluid>
          <v-row
            v-if="formatoSeleccionado && formatoSeleccionado.formatoId == 1"
            align="center">
            <v-col cols="6" md="2" v-if="filtro.estadoTransferenciaId == 1">
              <v-btn @click="generarArchivo('UC')" dark color="indigo"
                >Generar Archivo UC</v-btn
              >
            </v-col>
            <v-col cols="6" md="2" v-if="filtro.estadoTransferenciaId == 2">
              <v-btn @click="generarArchivo('TR')" dark color="pink"
                >Generar Archivo T</v-btn
              >
            </v-col>
            <v-col
              cols="6"
              md="2"
              v-if="
                filtro.estadoTransferenciaId == 1 ||
                filtro.estadoTransferenciaId == 2
              ">
              <v-switch
                v-model="filtro.marcaDefinitiva"
                label="Marcar Créditos"></v-switch>
            </v-col>
            <v-col
              cols="6"
              md="2"
              v-if="
                filtro.estadoTransferenciaId == 1 ||
                filtro.estadoTransferenciaId == 2
              ">
              <v-switch
                v-model="filtro.generarExcel"
                label="Generar Excel"></v-switch>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" lg="3">
              <v-btn @click="showProcesarArchivo = true" dark color="blue"
                >Procesar Archivo Respuesta IB</v-btn
              >
            </v-col>
          </v-row>
          <v-row
            v-if="formatoSeleccionado && formatoSeleccionado.formatoId == 2"
            align="center">
            <v-col v-if="filtro.estadoTransferenciaId == 1">
              <v-btn @click="generarArchivo('TR')">Generar Archivo</v-btn>
            </v-col>
            <v-col cols="6" v-if="filtro.estadoTransferenciaId == 1">
              <v-switch
                label="Activar Crédito luego de Generar Archivo"></v-switch>
            </v-col>
            <v-spacer></v-spacer>
          </v-row>

          <v-row
            v-if="formatoSeleccionado && formatoSeleccionado.esLlamadoApi"
            align="center">
            <v-col
              v-if="formatoSeleccionado && formatoSeleccionado.requiereCaja">
              <v-col>
                Seleccione la Caja en que se procesará la transferencia
              </v-col>
              <v-col>
                <v-autocomplete
                  v-model="filtro.cajaId"
                  :items="cajasEmpresa"
                  item-text="descripcion"
                  item-value="id"
                  label="Procesar en Caja"
                  no-data-text="Seleccione la Caja"
                  placeholder="Seleccione una"
                  :menu-props="{ minWidth: '400' }"></v-autocomplete>
              </v-col>
            </v-col>

            <v-col v-if="filtro.estadoTransferenciaId == 1">
              <v-btn
                color="success"
                :disabled="loading"
                @click="procesarEnvioApi()"
                >Procesar Envio API</v-btn
              >
            </v-col>
            <v-spacer></v-spacer>

            <v-col>
              <v-btn
                color="success"
                :disabled="loading"
                @click="generarReporteApi()"
                >Reporte Envios del Día</v-btn
              >
            </v-col>
            <v-col v-if="filtro.empresaId && formatoSeleccionado && formatoSeleccionado.descripcion && formatoSeleccionado.descripcion.includes('Envio API Banco Industrial')">
              <v-btn
                color="teal"
                dark
                :disabled="loading"
                @click="descargarLogBind()"
                >Descargar Log Bind</v-btn
              >
            </v-col>
            <v-spacer></v-spacer>
          </v-row>

          <v-row align="center">
            <v-spacer></v-spacer>
            <v-col cols="3">
              <v-switch
                v-model="showLiquidacionManual"
                label="Liquidación Manual"
                hint="Seleccione los Créditos a Liquidar, y luego presione aqui"
                persistent-hint></v-switch>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>

    <!-- proceso de liquidación manual -->
    <v-dialog v-model="showLiquidacionManual" width="1000">
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline"
          >Proceso de Liquidación Manual de Créditos</v-card-title
        >
        <v-card-text>
          <v-row align="center">
            <v-col> Seleccione la Caja en que se procesará la egreso </v-col>
            <v-col>
              <v-autocomplete
                v-model="filtro.cajaId"
                :items="cajasEmpresa"
                item-text="descripcion"
                item-value="id"
                label="Procesar en Caja"
                no-data-text="Seleccione la Caja"
                placeholder="Seleccione una"
                :menu-props="{ minWidth: '400' }"></v-autocomplete>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-row align="center">
              <v-data-table
                dense
                :headers="headersLiquidacionManual"
                :items="selectedRows"
                :rows-per-page="pagination.itemsPerPage"
                :options.sync="pagination"
                class="elevation-1"
                :footer-props="footer"
                item-key="id">
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-xs-left caption">
                      <v-icon
                        v-if="!item.statusProceso || item.statusProceso == 0"
                        color="green"
                        >check_circle_outline</v-icon
                      >
                      <v-progress-circular
                        v-if="item.statusProceso == 1"
                        color="green"
                        size="16"></v-progress-circular>
                      <v-icon v-if="item.statusProceso == 2" color="green"
                        >check_circle</v-icon
                      >
                      <v-icon v-if="item.statusProceso == 4" color="red"
                        >error</v-icon
                      >
                    </td>

                    <td class="text-xs-left caption">{{ item.origen }}</td>
                    <td class="text-xs-left caption">{{ item.producto }}</td>
                    <td class="text-xs-left caption">{{ item.cuil }}</td>
                    <td class="text-xs-left caption">{{ item.solicitante }}</td>
                    <td class="text-xs-left caption">
                      {{ item.monto | currency }}
                    </td>
                    <td class="text-xs-left caption">
                      {{ item.importeTransferencia | currency }}
                      <v-tooltip
                        bottom
                        v-if="
                          item.importeRefinanciaciones > 0 ||
                          item.cargosDescuento > 0
                        ">
                        <template v-slot:activator="{ on }">
                          <v-icon small color="green" v-on="on">info</v-icon>
                        </template>
                        <table>
                          <tr>
                            <span
                              >Se descontaron
                              {{ item.importeRefinanciaciones | currency }} por
                              Crédito/s Refinanciados o Renovados</span
                            >
                          </tr>
                          <tr>
                            <span
                              >Se descontaron
                              {{ item.cargosDescuento | currency }} por Cargos
                              del Plan</span
                            >
                          </tr>
                        </table>
                      </v-tooltip>
                    </td>
                    <td class="text-xs-left caption">
                      <v-chip small :color="item.empresaColor" label dark>{{
                        item.empresaShort
                      }}</v-chip>
                    </td>
                    <td class="text-xs-left caption">{{ item.errores }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-row>
            <v-row align="center">
              <v-col align-self="stretch">
                <v-btn
                  :disabled="loading"
                  text
                  dark
                  class="green"
                  @click.native="procesarLiquidacionManual">
                  Comenzar Proceso
                </v-btn>
              </v-col>
            </v-row>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- proceso de archivo de IB -->
    <v-dialog v-model="showProcesarArchivo" width="600">
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline"
          >Proceso de Archivo de Respuesta</v-card-title
        >
        <v-card-text>
          <v-row
            align="center"
            v-if="formatoSeleccionado && formatoSeleccionado.requiereCaja">
            <v-col>
              Seleccione la Caja en que se procesará la transferencia
            </v-col>
            <v-col>
              <v-autocomplete
                v-model="filtro.cajaId"
                :items="cajasEmpresa"
                item-text="descripcion"
                item-value="id"
                label="Procesar en Caja"
                no-data-text="Seleccione la Caja"
                placeholder="Seleccione una"
                :menu-props="{ minWidth: '400' }"></v-autocomplete>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col>
              <v-file-input
                v-model="archivosASubir"
                placeholder="Seleccione el Archivo a Procesar"
                label="Archivo a Procesar"
                chips
                @change="resultadoPreProceso = null"
                counter
                show-size
                prepend-icon="mdi-paperclip">
              </v-file-input>
            </v-col>

            <v-col cols="4" v-if="archivosASubir">
              <v-btn
                :disabled="loading"
                text
                class="black--text green"
                @click.native="preProcesarArchivo"
                small>
                Pre-Procesar &nbsp;
                <v-progress-circular
                  v-if="loading"
                  indeterminate
                  size="20"></v-progress-circular>
              </v-btn>
            </v-col>
          </v-row>

          <v-row align="center" v-if="resultadoPreProceso && archivosASubir">
            <v-row align="center">
              <v-data-table
                dense
                :headers="headersResultados"
                :items="recordsResultados"
                :rows-per-page="pagination.itemsPerPage"
                :options.sync="pagination"
                class="elevation-1"
                :footer-props="footer"
                item-key="id">
                <template v-slot:item="{ item }">
                  <tr>
                    <td class="text-xs-left caption">
                      <v-icon
                        v-if="item.procesar && item.statusProceso == 0"
                        color="green"
                        >check_circle_outline</v-icon
                      >
                      <v-progress-circular
                        v-if="item.procesar && item.statusProceso == 1"
                        color="green"
                        size="16"></v-progress-circular>
                      <v-icon
                        v-if="item.procesar && item.statusProceso == 2"
                        color="green"
                        >check_circle</v-icon
                      >
                      <v-icon
                        v-if="item.procesar && item.statusProceso == 4"
                        color="red"
                        >error</v-icon
                      >
                    </td>
                    <td class="text-xs-left caption">{{ item.infoArchivo }}</td>
                    <td class="text-xs-left caption">{{ item.resultado }}</td>
                    <td class="text-xs-left caption">{{ item.errores }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-row>
            <v-row align="center">
              <v-col align-self="stretch">
                <v-btn
                  :disabled="loading"
                  v-if="puedeProcesarArchivo"
                  text
                  dark
                  class="green"
                  @click.native="procesarArchivo">
                  Comenzar Proceso
                </v-btn>
              </v-col>
            </v-row>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- resultado proceso API -->
    <v-dialog v-model="showResultadoApi">
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline"
          >Proceso de Transferencias VIA API</v-card-title
        >
        <v-row align="center">
          <v-data-table
            dense
            :headers="headersResultados"
            :items="recordsResultados"
            :rows-per-page="pagination.itemsPerPage"
            :options.sync="pagination"
            class="elevation-1"
            :footer-props="footer"
            item-key="id">
            <template v-slot:item="{ item }">
              <tr>
                <td class="text-xs-left caption">
                  <v-icon
                    v-if="item.procesar && item.statusProceso == 0"
                    color="green"
                    >check_circle_outline</v-icon
                  >
                  <v-progress-circular
                    v-if="item.procesar && item.statusProceso == 1"
                    color="green"
                    size="16"></v-progress-circular>
                  <v-icon
                    v-if="item.procesar && item.statusProceso == 2"
                    color="green"
                    >check_circle</v-icon
                  >
                  <v-icon
                    v-if="item.procesar && item.statusProceso == 4"
                    color="red"
                    >error</v-icon
                  >
                </td>
                <td class="text-xs-left caption">{{ item.infoArchivo }}</td>
                <td class="text-xs-left caption">{{ item.resultado }}</td>
                <td class="text-xs-left caption">{{ item.errores }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-row>
      </v-card>
    </v-dialog>

    <!-- save progress -->
    <v-dialog v-model="showSaveProgress" width="400">
      <v-card :dark="$store.state.UiCustomUserSettings.temaOscuro">
        <v-card-title class="headline">Procesando ...</v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-row>
              <v-col> Generando Archivo... </v-col>
              <v-col>
                <v-progress-circular
                  v-if="saving"
                  indeterminate
                  color="red"></v-progress-circular>
                <v-icon large v-else>done</v-icon>
              </v-col>
            </v-row>
            <v-row>
              <v-col> Descargando archivo... </v-col>
              <v-col>
                <v-progress-circular
                  v-if="downloading"
                  indeterminate
                  color="red"></v-progress-circular>
                <v-icon large v-else>done</v-icon>
              </v-col>
            </v-row>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{ filtro }}
      <p></p>
    </template>
  </v-container>
</template>

<script>
import { http } from "@/axios";
import axios from "axios";
import { authHeader } from "@/helpers";
import Vue from "vue";
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  data() {
    return {
      showSaveProgress: false,
      saving: false,
      downloading: false,
      primeraBusquedaRealizada: false,
      loading: false,
      editMode: false,
      suspend: false,
      filterChanged: false,
      search: "", // valor para búsqueda
      pagination: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [""],
        page: 1,
        itemsPerPage: 5,
      },
      footer: {
        showFirstLastPage: true,
        //itemsPerPageOptions:[5,10,20, 50, 'All'],
        showCurrentPage: true,
      },
      totalItems: 0, // va afuera de pagination
      headers: [
        // definición de columnas
        { text: "Ver", value: "accion", width: 80, sortable: false },
        { text: "Origen del Crédito", value: "origen" },
        { text: "Producto", value: "producto" },
        { text: "Estado", value: "estadoTransferencia" },
        { text: "Cuil", value: "cuil" },
        { text: "Solicitante del Crédito", value: "solicitante" },
        { text: "Monto", value: "monto", width: 130 },
        { text: "Importe Tr.", value: "importeTransferencia", width: 130 },
        { text: "CBU", value: "cbu", width: 130 },
        { text: "Fecha de Ingreso", value: "fechaIngreso" },
        { text: "Empresa", value: "empresaNombre", width: 100 },
        { text: "", value: "", width: 100, sortable: false },
      ],
      headersConErrores: [
        // definición de columnas
        { text: "Ver", value: "accion", width: 80, sortable: false },
        { text: "Origen del Crédito", value: "origen" },
        { text: "Estado", value: "estadoTransferencia" },
        { text: "Cuil", value: "cuil" },
        { text: "Solicitante del Crédito", value: "solicitante" },
        { text: "Monto", value: "monto", width: 130 },
        { text: "Fecha de Ingreso", value: "fechaIngreso" },
        { text: "", value: "errores", width: 70 },
        { text: "Empresa", value: "empresaShort", width: 100 },
      ],
      headersResultados: [
        // definición de columnas
        { text: "", value: "procesar" },
        { text: "Info Archivo", value: "infoArchivo" },
        { text: "Resultado Banco", value: "resultado" },
        { text: "Errores", value: "errores" },
      ],
      headersLiquidacionManual: [
        // definición de columnas
        { text: "", value: "procesar" },
        { text: "Origen del Crédito", value: "origen" },
        { text: "Producto", value: "producto" },
        { text: "Cuil", value: "cuil" },
        { text: "Solicitante del Crédito", value: "solicitante" },
        { text: "Monto", value: "monto", width: 130 },
        { text: "Importe Tr.", value: "importeTransferencia", width: 130 },
        { text: "Empresa", value: "empresaNombre", width: 100 },
        { text: "Errores", value: "errores" },
      ],
      records: [], // registros
      recordsConErrores: [], // registros
      recordsResultados: [], // registros
      selectedRows: [],
      filtro: {
        marcaDefinitiva: true,
        empresaId: 0,
        canalVentaId: 0,
        productoId: 0,
        cajaId: 0,
        formatoId: null,
        periodo: { id: 1 },
        estadoTransferenciaId: "1",
      },
      canalesVenta: [],
      empresas: [],
      productos: [],
      formatos: [],
      cajas: [],
      showProcesarArchivo: false,
      rutaArchivo: "",
      archivosASubir: null,
      resultadoPreProceso: null,
      puedeProcesarArchivo: false,
      showLiquidacionManual: false,
      showResultadoApi: false,
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadCanalesVenta();
    this.loadProductos();
    this.loadCajas();
  },
  watch: {
    /* pagination :{
        handler(){
          if(this.primeraBusquedaRealizada)
            this.getItems(false);
        },
        deep: true
    }, */
    "filtro.empresaId": function () {
      this.loadFormatosEmpresa();
    },
    search() {
      this.getItems(true);
    },
  },
  computed: {
    ...mapGetters(["getActionFromLink", "user"]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    formatoSeleccionado() {
      if (!this.filtro.formatoId) return null;
      console.log(
        this.formatos.filter((e) => e.id == this.filtro.formatoId)[0]
      );
      return this.formatos.filter((e) => e.id == this.filtro.formatoId)[0];
    },
    cajasEmpresa: function () {
      console.log("this.filtro.empresaId");
      console.log(this.filtro.empresaId);
      if (this.filtro.empresaId > 0)
        return this.cajas.filter((c) => c.empresaId == this.filtro.empresaId);
      return null;
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "setActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
      "setReporteActivo",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    selectAllChanged(toggle) {
      this.selectedRows = [];
      if (toggle) {
        for (let index = 0; index < this.records.length; index++) {
          const element = this.records[index];

          this.selectedRows.push(element);
        }
      }
    },
    async getItems(resetPagination) {
      if (this.filtro.empresaId == 0) {
        this.alertWarning("Debe elegir una Empresa.");
        return;
      }

      if (this.filtro.periodo.desde === undefined) {
        this.alertWarning("Debe elegir un periodo para la búsqueda.");
        return;
      }

      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if (resetPagination) {
        this.pagination.page = 1;
      }

      this.loading = true;
      this.$validator.reset();

      let filter = this.filtro;

      let idCanalesVenta = filter.canalVentaId.toString();

      //Si se eligió TODOS ( y no tiene acceso a todos los canaes) armo un string con todos los canales de venta habilitados para el usuario.
      if (
        filter.canalVentaId === 0 &&
        !this.$store.state.user.accesoTodosCanalesVenta
      ) {
        for (var i = 0; i < this.canalesVenta.length; i++) {
          if (i === 0) idCanalesVenta = this.canalesVenta[i].id;
          else idCanalesVenta += "," + this.canalesVenta[i].id;
        }
      } else {
        idCanalesVenta = "0";
      }

      try {
        var result = await http.get(
          "creditos/listcreditostransferencia?empresaId=" +
            filter.empresaId +
            "&canalesVenta=" +
            idCanalesVenta +
            "&productoId=" +
            filter.productoId +
            "&estadoTransferenciaId=" +
            filter.estadoTransferenciaId +
            "&documento=" +
            filter.documento +
            "&fechaDesde=" +
            filter.periodo.desde +
            "&fechaHasta=" +
            filter.periodo.hasta
        );

        this.records = result.list.filter((i) => i.errores == "");
        this.recordsConErrores = result.list.filter((i) => i.errores != "");
        this.selectedRows = [];

        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.primeraBusquedaRealizada = true;
      this.loading = false;
    },
    async loadProductos() {
      this.loading = true;
      try {
        var result = await http.get("productos/");

        this.productos = result.list;

        this.productos.unshift({ id: 0, descripcion: "(Todos)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          "empresas/list/porusuario?usuarioId=" + this.user.id
        );

        this.empresas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCajas() {
      this.loading = true;
      try {
        var result = await http.get(
          "cajas/disponiblesporusuario?login=" + this.user.login
        );
        this.cajas = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get(
          "canalesventa/habilitadosparausuario?usuarioId=" + this.user.id
        );

        this.canalesVenta = result.list;

        this.canalesVenta.unshift({ id: 0, nombre: "(Todos)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadFormatosEmpresa() {
      this.loading = true;
      try {
        var result = await http.get(
          "empresas/list/formatostransferencia?empresaId=" +
            this.filtro.empresaId
        );
        this.formatos = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async generarArchivo(tipo) {
      // todo validar cantidad de casos seleccionados
      if (this.selectedRows.length == 0) {
        this.alertWarning("Por favor, seleccione los créditos a transferir ");
        return;
      }

      // paso la selección a un array de ids
      var ids = [];
      for (let index = 0; index < this.selectedRows.length; index++) {
        const element = this.selectedRows[index];
        ids.push(element.id);
      }

      var params = {};
      params.tipo = tipo;
      params.marcaDefinitiva = this.filtro.marcaDefinitiva;
      params.empresaId = this.filtro.empresaId;
      params.parametroTransferenciaId = this.filtro.formatoId;
      params.creditos = ids;
      //parms.generarExcel = this.filtro.generarExcel;

      this.loading = true;
      this.showSaveProgress = true;
      this.saving = true;
      this.downloading = true;

      try {
        var res = await http.post(
          "filegeneration/archivotransferencias",
          JSON.stringify({ parametros: params })
        );
        this.saving = false;

        this.alertSuccess("Archivo generado correctamente");

        //console.log(res)

        if (res.completo) {
          // descargo el archivo
          await this.downloadFile(res);
          this.downloading = false;
          Vue.$log.debug(this.filtro.generarExcel);
          if (this.filtro.generarExcel) {
            this.generarExcel(ids);
          }
        } else {
          this.alertError(
            "Se produjo un error al generar el archivo: " + res.Errores
          );
        }
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
      this.showSaveProgress = false;
    },
    async preProcesarArchivo() {
      this.loading = true;

      const formData = new FormData();
      formData.append("empresaId", this.filtro.empresaId);
      formData.append("parametroTransferenciaId", this.filtro.formatoId);
      formData.append("cajaId", this.filtro.cajaId);
      formData.append("files", this.archivosASubir);

      try {
        var res = await http.post(
          "/fileprocessing/archivoTransferencias",
          formData
        );

        //console.log(res)
        this.resultadoPreProceso = res;
        this.recordsResultados = this.resultadoPreProceso.detalle;
        this.puedeProcesarArchivo = true;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async procesarArchivo() {
      this.loading = true;

      try {
        this.puedeProcesarArchivo = false;

        for (
          let index = 0;
          index < this.resultadoPreProceso.detalle.length;
          index++
        ) {
          const element = this.resultadoPreProceso.detalle[index];

          // completo los datos necesarios para el desembolso
          element.cajaId = this.filtro.cajaId;
          element.formaDesembolsoId = 2; // transferencia
          element.banco = this.formatos.find(
            (f) => f.id == this.filtro.formatoId
          ).descripcion;
          element.numero = "";
          element.comentarios = "Proceso Masivo";

          if (element.procesar == true) {
            element.statusProceso = 1; // prosesando
            try {
              await http.post("/creditos/procesardesembolso", {
                parametros: element,
              });
              element.statusProceso = 2; // proceso OK
            } catch (error) {
              element.statusProceso = 4; // error
              element.errores = error;
            }
          }
        }

        this.alertSuccess("Proceso Finalizado");
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
    },
    async procesarLiquidacionManual() {
      if (this.selectedRows.length == 0) {
        this.alertWarning("Por favor, seleccione los créditos a liquidar ");
        return;
      }

      if (this.filtro.cajaId == 0) {
        this.alertWarning(
          "Por favor, seleccione la Caja en donde se imputará el egreso"
        );
        return;
      }

      this.loading = true;

      try {
        for (let index = 0; index < this.selectedRows.length; index++) {
          const element = this.selectedRows[index];

          // completo los datos necesarios para el desembolso
          element.cajaId = this.filtro.cajaId;
          element.formaDesembolsoId = 2; // transferencia
          element.banco = this.formatos.find(
            (f) => f.id == this.filtro.formatoId
          ).descripcion;
          element.numero = "";
          element.comentarios = "Proceso Masivo";
          element.deudaId = element.id; // pongo el Id del crédito en deudaId

          console.log(element);
          // this.loading = false;
          // return;

          element.statusProceso = 1; // procesando
          try {
            await http.post("/creditos/procesardesembolso", {
              parametros: element,
            });
            element.statusProceso = 2; // proceso OK
          } catch (error) {
            element.statusProceso = 4; // error
            element.errores = error;
          }
        }

        this.alertSuccess("Proceso Finalizado");
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
    },
    async procesarEnvioApi() {
      if (this.selectedRows.length == 0) {
        this.alertWarning("Por favor, seleccione los créditos a transferir");
        return;
      }

      if (this.formatoSeleccionado.requiereCaja && !this.filtro.cajaId) {
        this.alertWarning("Debe elegir la caja para relizar el egreso");
        return;
      }

      this.loading = true;

      try {
        for (let index = 0; index < this.selectedRows.length; index++) {
          const element = this.selectedRows[index];
          console.log(element);

          element.creditoId = element.id;
          element.parametroTransferenciaId = this.filtro.formatoId;
          element.cajaId = this.filtro.cajaId;

          element.statusProceso = 1; // procesando
          element.procesar = true;
          try {
            await http.post("/creditos/procesartransferenciaapi", {
              parametros: element,
            });
            element.statusProceso = 2; // proceso OK
            element.resultado = "PROCESO OK";
          } catch (error) {
            element.statusProceso = 4; // error
            element.errores = error;
            element.resultado = "ERROR";
          }
        }

        console.log(this.selectedRows);

        this.showResultadoApi = true;
        this.recordsResultados = this.selectedRows;
        this.archivosASubir = true; // error;

        this.alertSuccess("Proceso Finalizado");

        //refresco la lista
        this.getItems(false);
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.loading = false;
    },
    async generarReporteApi() {
      this.loading = true;
      try {
        let params = [];
        params.push({
          EmpresaId: this.filtro.empresaId,
          FormatoId: this.formatos.find((x) => x.id == this.filtro.formatoId)
            .formatoId,
          FechaDesde: this.$moment(new Date()).format("YYYY-MM-DD"),
          FechaHasta: this.$moment(new Date()).format("YYYY-MM-DD"),
        });

        this.setReporteActivo({
          reporte: "RespaldatorioTransferenciasApi.trdp",
          params: params,
        });
        window.open("/report-viewer");
      } catch (error) {
        // Error
        self.alertError(error);
      }

      this.loading = false;
    },
    async downloadFile(file, renameTo) {
      //convierto el string del path a base64 para poder mandarlo
      let base64String = "";
      base64String = btoa(file.fullPath);

      http
        .get("filemanagement/getfilebypath/" + base64String)
        .then((resp) => {
          let dataType = "";
          switch (resp.extension) {
            case ".doc":
            case ".docx":
            case ".DOC":
            case ".DOCX":
              dataType = "data:application/vnd.ms-word";
              break;
            case ".pdf":
            case ".PDF":
              dataType = "data:application/pdf";
          }

          //necesito hacer esto del arrayBuffer para que despues se pueda hacer el blob
          var arrayBuffer = this.base64ToArrayBuffer(resp.file);
          this.saveByteArray(
            renameTo ? renameTo : resp.fileName,
            arrayBuffer,
            dataType
          );
        })
        .catch((e) => this.alertError(e));
    },
    base64ToArrayBuffer(base64) {
      var binaryString = window.atob(base64);
      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },
    saveByteArray(fileName, byteArrayBuffer, dataType) {
      Vue.$log.debug(dataType);
      var blob = new Blob([byteArrayBuffer], { type: dataType });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
    },
    openFileDialog() {
      document.getElementById("file-upload").click();
    },
    onFileChange(e) {
      var self = this;
      Vue.$log.debug(e);
      Vue.$log.debug(e.target.files);

      var files = e.target.files;
      if (files.length > 0) {
        for (var i = 0; i < files.length; i++) {
          self.rutaArchivo = files[i].name;
        }
      }
    },
    async quitarItem(item) {
      Vue.$log.debug(item);
      let motivo = await this.$dialog.prompt({
        text: "",
        title: "Ingrese el motivo de la quita de la lista",
      });

      if (motivo != false) {
        var params = {};
        params.creditoId = item.id;
        params.subEstadoId = 53; //Dato Rechazado/Modificar
        params.motivo = motivo;
        this.loading = true;

        try {
          var result = await http.post(
            "creditos/cambiarestado",
            JSON.stringify({ parametros: params })
          );

          //await this.alertSuccess('Se ha modificado el estado del crédito.');

          if (result.acciones) {
            var mensaje = "";
            for (let index = 0; index < result.acciones.length; index++) {
              const accion = result.acciones[index];
              mensaje = mensaje + accion + "<br>";
            }
            const res = await this.$dialog.confirm({
              text: mensaje,
              title: "Se realizaron las siguientes acciones",
              actions: {
                false: "",
                true: {
                  text: "OK",
                  color: "primary",
                },
              },
              persistent: true, // Parece que no funciona...
            });

            //refresco la lista
            this.getItems(false);
          }
        } catch (error) {
          // Error
          this.alertError(error);
        }
        this.loading = false;
      }
    },
    async descargarLogBind() {
      this.loading = true;
      try {
        const baseURL = this.$store.state.ambiente.url;

        const response = await axios.get(baseURL + 'external/downloadbindtransferlog', {
          responseType: 'blob',
          headers: { Authorization: authHeader() },
        });

        const contentDisposition = response.headers['content-disposition'] || '';
        let fileName = 'Log - Transfer BIND API.txt';
        const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
        if (match) fileName = match[1];

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.alertError(error);
      }
      this.loading = false;
    },
    async generarExcel(ids) {
      var self = this;

      try {
        self.loading = true;

        var params = {};
        params.listaCreditos = ids.join();

        await http
          .post(
            "filegeneration/reportetransferencias",
            JSON.stringify({ parametros: params })
          )
          .then((resp) => {
            console.log(resp);

            if (resp.error) {
              self.alertError(resp.error);
            } else {
              self.alertSuccess(
                "Se generó correctamente el archivo. Aguarde unos instantese mientras se descarga el archivo..."
              );

              self.loading = true;
              self.downloadFile(resp, "Reporte Transferencias.csv");
              self.loading = false;
            }
          })
          .catch((e) => {
            self.alertError(e);
          });
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
  },
};
</script>
